// extracted by mini-css-extract-plugin
module.exports = {"container":"searchOverlay_container__-iHYu"};